module.exports = __webpack_public_path__ + "static/media/intro.bd0a9f76.mp3";